// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Qxm8","choiceBoxes":"toolbarselects_choiceBoxes__2sKA-","simpleField":"toolbarselects_simpleField__3cpCQ"};